<div class="permission-selector">

  <!-- Cabeçalho: toggle de modo (Simples/Avançado) + busca -->
  <div class="selector-header" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">
    <mat-button-toggle-group
      [value]="viewMode"
      (change)="setViewMode($event.value)"
      class="view-toggle">
      <mat-button-toggle
        *ngIf="hasFrontFirst"
        value="front-first"
        matTooltip="Árvore por tela (área do menu → tela → ação)">
        Por tela
      </mat-button-toggle>
      <mat-button-toggle value="grouped" matTooltip="Grupo e subgrupo (ações amigáveis)">
        Simples
      </mat-button-toggle>
      <mat-button-toggle value="ungrouped" matTooltip="Abre as permissões granulares (avançado)">
        Avançado
      </mat-button-toggle>
    </mat-button-toggle-group>

    <mat-form-field *ngIf="!isFrontFirst" appearance="outline" class="search-field">
      <mat-label>Pesquisar permissões</mat-label>
      <input matInput [(ngModel)]="searchText" [ngModelOptions]="{ standalone: true }" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <!-- Filtro de categoria (opcional) -->
  <mat-form-field
    *ngIf="!isFrontFirst && categoryOptions.length > 0"
    appearance="outline"
    class="category-field">
    <mat-label>Categoria</mat-label>
    <mat-select [(ngModel)]="selectedCategory" [ngModelOptions]="{ standalone: true }">
      <mat-option value="ALL">TODAS</mat-option>
      <mat-option *ngFor="let opt of categoryOptions" [value]="opt.value">
        {{ opt.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Ações em massa -->
  <!-- Modo "Por tela": árvore pronta do wazir-api (tem busca, expandir/recolher e limpar próprios) -->
  <app-front-first-permission-tree
    *ngIf="isFrontFirst"
    class="front-first-host"
    [groups]="frontFirstGroups"
    [loading]="frontFirstLoading"
    [disabled]="disabled"
    [selectedIds]="selectedIds"
    (selectedIdsChange)="onFrontFirstSelectedIdsChange($event)">
  </app-front-first-permission-tree>

  <div *ngIf="!isFrontFirst" class="bulk-actions" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="4px">
    <mat-checkbox
      [checked]="isAllVisibleSelected"
      [indeterminate]="!isAllVisibleSelected && selectedCount > 0"
      [disabled]="disabled"
      (change)="toggleAllVisible($event.checked)"
      class="select-all-checkbox">
      Marcar todas exibidas
    </mat-checkbox>

    <button mat-stroked-button type="button" (click)="clearAllVisible()" [disabled]="disabled" class="bulk-btn">
      <mat-icon>clear_all</mat-icon> Limpar
    </button>
    <ng-container *ngIf="viewMode === 'grouped'">
      <button
        mat-stroked-button
        type="button"
        (click)="hasExpandedGroups ? collapseAll() : expandAll()"
        class="bulk-btn">
        <mat-icon>{{ hasExpandedGroups ? 'unfold_less' : 'unfold_more' }}</mat-icon>
        {{ hasExpandedGroups ? 'Recolher' : 'Expandir' }}
      </button>
    </ng-container>
    <button
      mat-stroked-button
      type="button"
      class="bulk-btn only-marked-btn"
      [class.active]="onlyMarked"
      matTooltip="Mostrar só o que está marcado (grupos/subgrupos com pelo menos 1 selecionada)"
      (click)="toggleOnlyMarked()">
      <mat-icon>{{ onlyMarked ? 'filter_alt' : 'filter_alt_off' }}</mat-icon> Só marcados
    </button>
  </div>

  <!-- Estatísticas -->
  <div *ngIf="!isFrontFirst" class="selector-stats">
    <strong>{{ selectedCount }}</strong> de {{ totalCount }} selecionadas
  </div>

  <!-- Carregando -->
  <div *ngIf="!isFrontFirst && loading" class="selector-loading" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    <mat-spinner diameter="20"></mat-spinner>
    <span>Carregando catálogo...</span>
  </div>

  <!-- Árvore Grupo → Subgrupo → (Avançado) granular -->
  <div *ngIf="!isFrontFirst && !loading" class="permissions-list">
    <ng-container *ngIf="visibleGroups.length > 0; else emptyTree">
      <div *ngFor="let group of visibleGroups; trackBy: trackByGroupId" class="group-item">

        <!-- Nível 1: GRUPO -->
        <div class="group-header" fxLayout="row" fxLayoutAlign="start center">
          <mat-checkbox
            class="group-checkbox"
            [checked]="isGroupChecked(group)"
            [indeterminate]="isGroupIndeterminate(group)"
            [disabled]="disabled"
            (change)="toggleGroup(group, $event.checked)">
            <span class="group-name">{{ group.name }}</span>
          </mat-checkbox>

          <button
            mat-icon-button
            type="button"
            class="expand-btn"
            [matTooltip]="isExpanded(group.id) ? 'Recolher' : 'Expandir'"
            (click)="toggleExpand(group.id)">
            <mat-icon>{{ isExpanded(group.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>

        <!-- Nível 2: SUBGRUPOS -->
        <div *ngIf="isExpanded(group.id)" class="group-subgroups">
          <ng-container *ngIf="getVisibleSubgroups(group).length > 0; else emptyGroup">
            <div *ngFor="let sub of getVisibleSubgroups(group); trackBy: trackBySubKey" class="subgroup-item">
              <div class="subgroup-header" fxLayout="row" fxLayoutAlign="start center">
                <mat-checkbox
                  class="subgroup-checkbox"
                  [checked]="isSubgroupChecked(sub)"
                  [indeterminate]="isSubgroupIndeterminate(sub)"
                  [disabled]="disabled"
                  (change)="toggleSubgroup(sub, $event.checked)">
                  <span class="subgroup-name">{{ sub.name }}</span>
                </mat-checkbox>

                <!-- 3º nível só no modo Avançado -->
                <button
                  *ngIf="isAdvanced"
                  mat-icon-button
                  type="button"
                  class="expand-btn"
                  [matTooltip]="isSubgroupExpanded(sub.key) ? 'Recolher' : 'Ver permissões'"
                  (click)="toggleSubgroupExpand(sub.key)">
                  <mat-icon>{{ isSubgroupExpanded(sub.key) ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
              </div>

              <!-- Nível 3: PERMISSÕES granulares (Avançado + subgrupo expandido) -->
              <div
                *ngIf="isAdvanced && isSubgroupExpanded(sub.key)"
                class="subgroup-permissions">
                <mat-checkbox
                  *ngFor="let perm of getVisiblePermissions(sub); trackBy: trackByPermId"
                  [class.dimmed]="isDimmed(perm.id)"
                  [matTooltip]="isDimmed(perm.id) ? 'Desmarcada — some ao reaplicar o filtro Só marcados' : ''"
                  [checked]="isSelected(perm.id)"
                  [disabled]="disabled"
                  (change)="togglePermission(perm.id, $event.checked)">
                  {{ perm.name }}
                </mat-checkbox>
              </div>
            </div>
          </ng-container>

          <ng-template #emptyGroup>
            <span class="empty-hint" *ngIf="getVisibleLoose(group).length === 0">
              Nenhuma permissão disponível neste grupo.
            </span>
          </ng-template>

          <!-- Permissões "soltas" (sem convenção CRUD/@Access): só no Avançado -->
          <div *ngIf="isAdvanced && getVisibleLoose(group).length > 0" class="group-loose">
            <span class="loose-hint">Outras permissões</span>
            <mat-checkbox
              *ngFor="let perm of getVisibleLoose(group); trackBy: trackByPermId"
              [class.dimmed]="isDimmed(perm.id)"
              [matTooltip]="isDimmed(perm.id) ? 'Desmarcada — some ao reaplicar o filtro Só marcados' : ''"
              [checked]="isSelected(perm.id)"
              [disabled]="disabled"
              (change)="togglePermission(perm.id, $event.checked)">
              {{ perm.name }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #emptyTree>
      <div class="empty-state">
        <ng-container [ngSwitch]="true">
          <span *ngSwitchCase="onlyMarkedEmptySnapshot">Nenhuma permissão selecionada.</span>
          <span *ngSwitchCase="!!searchText">Nenhum resultado para "{{ searchText }}".</span>
          <span *ngSwitchDefault>Nenhum grupo de permissões disponível.</span>
        </ng-container>
      </div>
    </ng-template>
  </div>

</div>
